var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"li-item",class:{ 'seccion-activa': _vm.opciones.activo },on:{"click":function($event){return _vm.cambiarFiltro({estado:false, texto:'-',value:'-',filtro:'-'})}}},[_c('router-link',{attrs:{"to":{name: _vm.opciones.ruta}}},[_c('fas',{attrs:{"icon":['fas', _vm.opciones.icon]}}),_vm._v(" "+_vm._s(_vm.opciones.title)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }